import serialize from 'form-serialize';
import _fromPairs from 'lodash/fromPairs';
import _isEqual from 'lodash/isEqual';
import _mapValues from 'lodash/mapValues';

var _normalizeValues = function _normalizeValues(data) {
  if (typeof data !== 'object') {
    return data;
  }

  if (Array.isArray(data)) {
    if (_isEqual(data, Object.values(data))) {
      return data.filter(function (value) {
        return value !== '';
      }).map(function (value) {
        return _normalizeValues(value);
      });
    }

    data = _fromPairs(Object.entries(data));
  }

  return _mapValues(data, function (value) {
    return _normalizeValues(value);
  });
};

var serializeForm = function serializeForm($$form) {
  var data = serialize($$form, {
    hash: true,
    empty: true
  });
  return _normalizeValues(data);
};

export default serializeForm;